var generateBundleCheckoutUrl, getFirstWarrantyOption;

getFirstWarrantyOption = function(optionUuid, dealOptionWarranties) {
  var ref;
  if (dealOptionWarranties == null) {
    dealOptionWarranties = {};
  }
  return (ref = dealOptionWarranties[optionUuid]) != null ? ref[0] : void 0;
};

generateBundleCheckoutUrl = function(dealUuid, optionId, warrantyOption) {
  var warrantyDealUuid, warrantyOptionId;
  warrantyDealUuid = warrantyOption.warrantyDealUuid, warrantyOptionId = warrantyOption.warrantyOptionId;
  return "/checkout/bundle?type=warranty&items=" + dealUuid + ":" + optionId + "," + warrantyDealUuid + ":" + warrantyOptionId;
};

module.exports = {
  getFirstWarrantyOption: getFirstWarrantyOption,
  generateBundleCheckoutUrl: generateBundleCheckoutUrl
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9nb29kc193YXJyYW50eS9jb21tb24vaGVscGVycy5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9ha2VzaGFyaS9uYXBpc3RyYW5vL2J1aWxkLzE0OTU2NjA4OTgyNDktNDM5Ni9wcm9kdWN0aW9uLTIwMTcuMDUuMjRfMjEuMTkvZGVhbC9tb2R1bGVzL2dvb2RzX3dhcnJhbnR5L2NvbW1vbi9oZWxwZXJzLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOztBQUFBLHNCQUFBLEdBQXlCLFNBQUMsVUFBRCxFQUFhLG9CQUFiO0FBQ3ZCLE1BQUE7O0lBRG9DLHVCQUF1Qjs7K0RBQ3pCLENBQUEsQ0FBQTtBQURYOztBQUd6Qix5QkFBQSxHQUE0QixTQUFDLFFBQUQsRUFBVyxRQUFYLEVBQXFCLGNBQXJCO0FBQzFCLE1BQUE7RUFBQyxrREFBRCxFQUFtQjtTQUNuQix1Q0FBQSxHQUF3QyxRQUF4QyxHQUFpRCxHQUFqRCxHQUFvRCxRQUFwRCxHQUE2RCxHQUE3RCxHQUFnRSxnQkFBaEUsR0FBaUYsR0FBakYsR0FBb0Y7QUFGMUQ7O0FBSTVCLE1BQU0sQ0FBQyxPQUFQLEdBQWlCO0VBQUMsd0JBQUEsc0JBQUQ7RUFBeUIsMkJBQUEseUJBQXpCIn0=
